import(/* webpackMode: "eager" */ "/var/www/turivana/frontend/src/app/[locale]/experiencias/page.tsx");
